export function initHeaderInteractions(root = document) {
  const dropdowns = root.querySelectorAll('[data-header-dropdown]');

  if (!dropdowns.length) {
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ANIMATION_DURATION = 300;

  function closeDropdown(dropdown) {
    const toggle = dropdown.querySelector('[data-header-dropdown-toggle]');
    const panel = dropdown.querySelector('[data-header-dropdown-panel]');

    if (!toggle || !panel || !dropdown.classList.contains('is-open')) {
      return;
    }

    toggle.setAttribute('aria-expanded', 'false');
    dropdown.classList.remove('is-open');

    if (reduceMotion) {
      panel.hidden = true;
      panel.style.maxHeight = '';
      panel.style.opacity = '';
      return;
    }

    // Start from current height
    panel.style.maxHeight = `${panel.scrollHeight}px`;
    panel.style.opacity = '1';

    // Force reflow
    panel.offsetHeight;

    requestAnimationFrame(() => {
      panel.style.maxHeight = '0px';
      panel.style.opacity = '0';
    });

    window.setTimeout(() => {
      if (!dropdown.classList.contains('is-open')) {
        panel.hidden = true;
        panel.style.maxHeight = '';
        panel.style.opacity = '';
      }
    }, ANIMATION_DURATION);
  }

  function openDropdown(dropdown) {
    const toggle = dropdown.querySelector('[data-header-dropdown-toggle]');
    const panel = dropdown.querySelector('[data-header-dropdown-panel]');

    if (!toggle || !panel || dropdown.classList.contains('is-open')) {
      return;
    }

    panel.hidden = false;

    toggle.setAttribute('aria-expanded', 'true');
    dropdown.classList.add('is-open');

    if (reduceMotion) {
      panel.style.maxHeight = 'none';
      panel.style.opacity = '1';
      return;
    }

    panel.style.maxHeight = '0px';
    panel.style.opacity = '0';

    const fullHeight = panel.scrollHeight;

    // Force reflow
    panel.offsetHeight;

    requestAnimationFrame(() => {
      panel.style.maxHeight = `${fullHeight}px`;
      panel.style.opacity = '1';
    });

    window.setTimeout(() => {
      if (dropdown.classList.contains('is-open')) {
        panel.style.maxHeight = 'none';
      }
    }, ANIMATION_DURATION);
  }

  dropdowns.forEach((dropdown) => {
    const toggle = dropdown.querySelector('[data-header-dropdown-toggle]');

    if (!toggle) {
      return;
    }

    toggle.addEventListener('click', (event) => {
      event.preventDefault();

      const isOpen = dropdown.classList.contains('is-open');

      // Close others
      dropdowns.forEach((item) => {
        if (item !== dropdown) {
          closeDropdown(item);
        }
      });

      if (isOpen) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    if (target.closest('[data-header-dropdown]')) {
      return;
    }

    dropdowns.forEach(closeDropdown);
  });
}